<template>
  <div id="part--similar-parts">
    <Spin v-if="loading"></Spin>
    <Card v-for="(p, index) in similarParts" :key="index">
      <p slot="title">{{ p.name }}</p>
      <p>{{ p.shortDescription }}</p>
      <p style="margin-top: 12px;">
        {{ p.category.name }}
      </p>
      <p class="ivu-badge" style="margin-top: 14px;">
        <span v-if="p.octopartUrl" class="ivu-badge-count ivu-badge-count-alone" style="background-color: #f8f8f9; display: inline; color: #657180;">
          <a style="color: #2d8cf0;" :href="p.octopartUrl" target="_blank" rel="noreferrer">Octopart</a>
        </span>
        <span v-if="p.bestDatasheet" class="ivu-badge-count ivu-badge-count-alone" style="background-color: #f8f8f9; display: inline;">
          <a style="color: #2d8cf0;" :href="p.bestDatasheet.url" target="_blank" rel="noreferrer">datasheet</a>
        </span>
      </p>
    </Card>
    <div v-if="!loading && similarParts.length === 0">{{ $t('part.similar_parts_empty_result') }}</div>
  </div>
</template>

<script>
import { getSimilarParts } from '@/api/part'
export default {
  name: 'SimilarParts',
  props: {
    componentType: {
      type: String,
      required: true
    },
    id: {
      required: true
    }
  },
  data () {
    return {
      loading: false,
      similarParts: []
    }
  },
  mounted () {
    this.loadSimilarParts(this.componentType, this.id)
  },
  methods: {
    loadSimilarParts (type, id) {
      this.loading = true
      getSimilarParts(type, id).then(resp => {
        this.similarParts = resp.data
      }).finally(() => {
        this.loading = false
      })
    }
  },
  watch: {
    specification: function (val) {
      this.loadSimilarParts(val)
    }
  }
}
</script>
